<template>
	<div>
		<v-tabs v-model="pricingTab" class="mb-2" background-color="transparent">
			<v-tab>Preturi de baza</v-tab>
			<v-tab>Ajustari modele</v-tab>
			<v-tab>Discounturi</v-tab>
			<v-tab>Taxe servicii</v-tab>
			<v-tab>Praguri & TVA</v-tab>
		</v-tabs>

		<div class="px-4 pt-4 pb-8">
			<div class="mb-4">
				<h6 class="text-lg uppercase tracking-wider text-gray-500 mb-1">
					{{ title }}
				</h6>
				<v-label class="text-base">
					{{ description }}
				</v-label>
			</div>

			<div v-if="loading" class="progress">
				<div class="indeterminate"></div>
			</div>

			<div v-else-if="error">
				<p class="text-red-500 mb-4">Eroare de incarcare!</p>
				<v-btn @click="fetchAll" color="teal" class="uppercase white--text">Reincarca</v-btn>
			</div>

			<v-tabs-items v-else-if="loaded" v-model="pricingTab" class="transparent">
				<v-tab-item>
					<div class="pt-4">
						<BasePrices :namespace="namespace" />
					</div>
				</v-tab-item>
				<v-tab-item>
					<div class="pt-4">
						<ModelAdjustments :namespace="namespace" />
					</div>
				</v-tab-item>
				<v-tab-item>
					<div class="flex flex-col gap-4 pt-4">
						<GapRates :namespace="namespace" />
						<VolumeTiers :namespace="namespace" />
					</div>
				</v-tab-item>
				<v-tab-item>
					<div class="pt-4">
						<RegionServiceFees :namespace="namespace" />
					</div>
				</v-tab-item>
				<v-tab-item>
					<div class="flex flex-col gap-4 pt-4">
						<MinArea :namespace="namespace" />
						<VatRate :namespace="namespace" />
					</div>
				</v-tab-item>
			</v-tabs-items>
		</div>
	</div>
</template>

<script>
import GapRates from './Configurator/GapRates.vue'
import VolumeTiers from './Configurator/VolumeTiers.vue'
import MinArea from './Configurator/MinArea.vue'
import VatRate from './Configurator/VatRate.vue'
import RegionServiceFees from './Configurator/RegionServiceFees.vue'
import BasePrices from './Configurator/BasePrices.vue'
import ModelAdjustments from './Configurator/ModelAdjustments.vue'

export default {
	name: "FencePricingSettings",
	components: {
		GapRates,
		VolumeTiers,
		MinArea,
		VatRate,
		RegionServiceFees,
		BasePrices,
		ModelAdjustments
	},
	props: {
		// which fence pricing store to work against: 'configuratorPricing' or 'hubFencePricing'
		namespace: {
			type: String,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		description: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			pricingTab: null
		};
	},
	computed: {
		section() {
			return this.$store.state[this.namespace];
		},
		loading() {
			return this.section.loadingPricingConfig
				|| this.section.loadingBasePrices
				|| this.section.loadingModelAdjustments;
		},
		error() {
			return this.section.pricingConfigError
				|| this.section.basePricesError
				|| this.section.modelAdjustmentsError;
		},
		// these three endpoints feed the tabs, so nothing renders until each one answered.
		// region fees load per country, inside their own card
		loaded() {
			return !!this.section.pricingConfig
				&& !!this.section.basePrices
				&& !!this.section.modelAdjustments;
		}
	},
	methods: {
		fetchAll() {
			this.$store.dispatch(this.namespace + '/fetchPricingConfig');
			this.$store.dispatch(this.namespace + '/fetchBasePrices');
			this.$store.dispatch(this.namespace + '/fetchModelAdjustments');
			// no-op on a store without a model list of its own, i.e. the configurator's
			this.$store.dispatch(this.namespace + '/fetchModels');
		}
	},
	watch: {
		// if Vue ever patches one instance into the other (both settings tabs use this
		// component), created() won't run again for the new store - load it here
		namespace() {
			this.fetchAll();
		}
	},
	created() {
		this.fetchAll();
	}
};
</script>

<style scoped>
/* the tabs bar itself is transparent, so each trigger carries its own white surface */
.v-tab {
	background-color: #fff;
	border-radius: 8px 8px 0 0;
}
</style>
